import { HttpService } from './../../../core/http/http.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MedicationsService {

  constructor(private httpService: HttpService) { }

  getMedications(q: string) {

    return this.httpService.reqBackend('medicationsapi/search', {
      params: {
        q
      },
      method: 'get'
    });
  }
}
